// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3bWTO","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__29EeV"};